import { render } from "./uil-sort-amount-down.vue?vue&type=template&id=fce44c30"
import script from "./uil-sort-amount-down.vue?vue&type=script&lang=js"
export * from "./uil-sort-amount-down.vue?vue&type=script&lang=js"
script.render = render

export default script